export default "__VITE_ASSET__B9SP2qv2__"